import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import './HowItWorksContent.css';

const HowItWorksContent = () => {
    // State to manage the visibility of the two sections
    const [telepsychiatryOpen, setTelepsychiatryOpen] = useState(false);
    const [howItWorksOpen, setHowItWorksOpen] = useState(false);

    // Toggle functions
    const toggleTelepsychiatry = () => setTelepsychiatryOpen(!telepsychiatryOpen);
    const toggleHowItWorks = () => setHowItWorksOpen(!howItWorksOpen);

    return (
        <section id="howItWorks" className="how-it-works-section">
            <div className="container">
                <h1>How Mindspace Works</h1>
                
                {/* ======================================================= */}
                {/* ACCORDION ITEM 1: WHAT IS TELEPSYCHIATRY? */}
                {/* ======================================================= */}
                <div className={`accordion-item block-shadow ${telepsychiatryOpen ? 'active' : ''}`}>
                    <div className="accordion-header" onClick={toggleTelepsychiatry}>
                        <h2>What is Telepsychiatry?</h2>
                        <FontAwesomeIcon 
                            icon={telepsychiatryOpen ? faChevronUp : faChevronDown} 
                            className="toggle-icons"
                        />
                    </div>
                    
                    <div className={`accordion-content ${telepsychiatryOpen ? 'open' : ''}`}>
                        <p>
                            Telepsychiatry is the delivery of psychiatric assessment and care using secure video and audio communication technologies. This allows you to meet with your licensed provider from the comfort and privacy of your own space.
                        </p>
                        
                        <ul className="feature-list">
                            <li>
                                <strong>HIPAA Compliant Platform:</strong> All consultations are conducted via a **secure, encrypted platform** to ensure your privacy and confidentiality, fully compliant with **HIPAA regulations**.
                            </li>
                            <li>
                                <strong>Initial Consultation:</strong> Your first appointment is an in-depth **45-minute to 1-hour** session designed for comprehensive assessment, diagnosis, and establishing a personalized treatment plan.
                            </li>
                            <li>
                                <strong>Electronic Prescribing:</strong> When medication is part of your treatment plan, prescriptions are handled efficiently and securely, sent directly and **electronically to your preferred pharmacy**.
                            </li>
                            <li>
                                <strong>Flexible Follow-ups:</strong> Easily schedule follow-up appointments for medication management, check-ins, or ongoing therapy based on your needs, all via our virtual platform.
                            </li>
                        </ul>
                    </div>
                </div>

                {/* ======================================================= */}
                {/* ACCORDION ITEM 2: NEW PATIENT & PROVIDER REFERRAL PROCESS (HOW IT WORKS) */}
                {/* ======================================================= */}
                <div className={`accordion-item block-shadow ${howItWorksOpen ? 'active' : ''}`}>
                    <div className="accordion-header" onClick={toggleHowItWorks}>
                        <h2>How It Works</h2>
                        <FontAwesomeIcon 
                            icon={howItWorksOpen ? faChevronUp : faChevronDown} 
                            className="toggle-icons"
                        />
                    </div>
                    
                    <div className={`accordion-content ${howItWorksOpen ? 'open' : ''}`}>
                        <ol className="step-list">
                            <li className="step-item">
                                <strong>Step 1: Fill Out Registration Form</strong>
                                <p>Complete our simple online registration form to provide necessary preliminary information. This is the first step toward securing your initial consultation.</p>
                            </li>

                            <li className="step-item">
                                <strong>Step 2: Team Review & Onboarding Package</strong>
                                <p>Our clinical team will review your form within 24 hours. Following review, we will send you:</p>
                                <ul>
                                    <li>The required intake consent form.</li>
                                    <li>A secure payment link for your services.</li>
                                    <li>Access to our online calendar for scheduling your appointment.</li>
                                </ul>
                            </li>

                            <li className="step-item">
                                <strong>Screening & Fit Notification</strong>
                                <p>
                                    If we find that Mindspace may not be a good fit for your specific needs, we will let you know within 24 hours of your submission, ensuring you can quickly pursue other appropriate care options.
                                </p>
                            </li>
                            
                            <li className="step-item">
                                <strong>Step 3: Referrals from Hospitals/Providers</strong>
                                <p>
                                    If you are a hospital, PHP (Partial Hospitalization Program), or another provider identifying a patient:
                                </p>
                                <ul>
                                    <li>Please fill out the registration form on the patient's behalf.</li>
                                    <li>Also submit the patient's psychiatric condition summary along with a needs list (e.g., medication management, specific therapeutic interventions).</li>
                                </ul>
                            </li>
                            
                            <li className="step-item">
                                <strong>Step 4: Appointment Reminder</strong>
                                <p>
                                    To help you prepare, we will send you a reminder message about your upcoming appointment 24 hours prior to your scheduled time.
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
                
            </div>
        </section>
    );
};

export default HowItWorksContent;